export interface OptionListItem {
  name: string;
  value: any;
  active: boolean;
  checked?: boolean;
}
